module.exports = {"530124001":"永定街道","530124002":"大营街道","530124103":"罗免镇","530124104":"赤鹫镇","530124105":"东村镇","530124106":"款庄镇","530124107":"散旦镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530124.json
// module id = 2680
// module chunks = 0